<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ch1"> </p>
<p class="H1"><span class="epub-intro">INTRODUCTION TO</span></p>
<p class="H1SUB"><span class="ePub-B">“SAM BELOW PAR”</span></p>
<p class="sp1"> </p>
<p class="TNI">I am not a golfer. I’m a writer. Hardly any of the writers I know have the time to play golf. Writers <span class="ePub-I">write</span>. They don’t fritter away hour upon hour trying to knock a little white ball into a hole in the ground.</p>
<p class="TX">But once I fell in love with the ravishing Rashida, who is an ardent golfer, I perforce began to learn a few things about the game. And as I did, Sam Gunn came up and tapped me on my metaphysical shoulder.</p>
<p class="TX">“I want to build a golf course,” Sam said to me. “On the Moon.”</p>
<p class="TX">Sam is a scoundrel, of course. A skirt chaser. A man who can bend the rules into pretzels. A little guy, physically, Sam is always battling against the Big Guys: the corporate “suits,” the government bureaucrats, the rich and powerful. Sam makes and loses fortunes the way you or I change socks. But he has a heart as big as the solar system, and despite his many enemies, he also has a legion of friends.</p>
<p class="TX">But a golf course on the Moon? I mean, the Moon is a new frontier, yes, but who would want to build a golf course on its airless, barren surface?</p>
<p class="TX">Who else but Sam Gunn?</p>
<p class="TX"><span class="ePub-I">Why</span> would he want to build a golf course on the Moon?</p>
<p class="TX">Thereby hangs a tale.… </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?09634cf2